<body [style.backgroundColor]="backgroundColor">
    <div style="position: relative; display: flex; justify-content: center;">
        <div style="max-width: 760px; width: 100%; position: relative;">
            <header *ngIf="showHeader"></header>
            <router-outlet></router-outlet>
            <footer *ngIf="showFooter"></footer>
        </div>
    </div>
</body>
